<template>
	<div class="product">
		<article v-for="bookeeproduct in bookeeproducts" :key="bookeeproduct.id" class="product__item"
		v-bind:class="{ 'product__item--hidden' : filter.length != 0 && !filter.includes(bookeeproduct.bookeeType.id),
		'product__item--loading' : loading }">
		<header class="product__class">{{bookeeproduct.bookeeType.name}}</header>
		<div class="product__imagewrap"
		:style="{ backgroundImage: 'url(\'' + getProductPicture(bookeeproduct) + '\')' }" >
	</div>
	<div class="product__infowrap">

		<h1 class="product__title">
			{{bookeeproduct.name}}
		</h1>
		<dl class="product__specs specs">
			<template v-for="spec in getProductSpecs(bookeeproduct)">
				<dt class="specs__key" :key="spec.key">{{spec.key}}</dt>
				<dd class="specs__val" :key="spec.value">{{spec.value}}</dd>
			</template>
		</dl>
		<div class="product__desc">
			{{getProductDescription(bookeeproduct)}}
		</div>
	</div>

	<!-- <button type="button" class="product__button button"
		@click="placesFor(bookeeproduct.bookeeType.id)">
		<template v-if="loading">
			&nbsp;
		</template>
		<template v-else>
			Zu den Stationen
			<svg class="button__arrow" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
				<path d="M310.627 438.627l160-160c12.497-12.496 12.497-32.758 0-45.255l-160-160c-12.497-12.496-32.758-12.496-45.255 0s-12.497 32.758 0 45.255l105.373 105.373h-306.745c-17.673 0-32 14.327-32 32s14.327 32 32 32h306.745l-105.373 105.373c-6.248 6.248-9.372 14.438-9.372 22.627s3.124 16.379 9.372 22.627c12.497 12.497 32.758 12.497 45.255 0z"></path>
			</svg>
		</template>
	</button> -->
</article>
</div>
</template>

<script>
import axios from 'axios';

//const HOMERS_CAR = 'https://media.wired.com/photos/593252a2a31264584499416b/master/w_200,c_limit/the-homer-inline2.jpg';

export default {
	name: 'bookeeproduct',
	props: ['filter'],
	data () {
		return {
			loading: true,
			bookeeproducts: Array(4).fill(0).map((o, i) => {
				return {
					'id': i,
					'provId': '0',
					'name': '',
					'remarks': [
						{
							'name': 'GLOBALPROPERTIES',
							'infoType': [
								'MARKETING'
							],
							'contentType': 'text/plain',
							'content': '████: ██\n████: ██\n██████: ███ █\n'
						},
						{
							'infoType': [
								'MARKETING'
							],
							'contentType': 'image/jpeg',
							'reference': ''
						},
						{
							'infoType': [
								'MARKETING'
							],
							'contentType': 'text/plain',
							'content': '███████  █████  ██   █████ ██ █ ████ ███████ ██  ███ ███ █'
						}
					],
					'bookeeType': {
						'id': i,
						'provId': '0',
						'name': '████████'.substr(Math.floor(Math.random() * 5) + 1)
					}
				};
			})
		};
	},
	mounted () {
		axios.get('bookeeproducts?expand=remark&expand=bookeeType&provId=47')
			.then(response => {
				this.bookeeproducts = response.data;
				this.bookeeproducts.sort((a,b) => (a.bookeeType.name.localeCompare(b.bookeeType.name, undefined, {numeric: true})));
				this.loading = false;
			}).catch(error => {
				console.log(error);
			});
	},
	methods: {
		placesFor (bookeeTypeId) {
			console.log('placesFor called for bookee id', bookeeTypeId);
		},
		getProductPicture (bookeeProduct) {
			if (this.loading) {
				return '';
			}
			if (bookeeProduct.remarks) {
				const remark = bookeeProduct.remarks.filter(r => r.infoType.indexOf('MARKETING') > -1)
					.filter(r => r.contentType.startsWith('image/'))[0];
				if (remark) {
					return remark.reference + '?width=640';
				} else {
					return '';
				}
			} else {
				return '';
			}
		},
		getProductDescription (bookeeProduct) {
			const remark = bookeeProduct.remarks.filter(r => r.infoType.indexOf('MARKETING') > -1)
				.filter(r => r.contentType === 'text/plain')
				.filter(r => r.name !== 'GLOBALPROPERTIES')[0];
			if (remark) {
				return remark.content;
			}
		},
		getProductSpecs (bookeeProduct) {
			const remark = bookeeProduct.remarks.filter(r => r.infoType.indexOf('MARKETING') > -1)
				.filter(r => r.name === 'GLOBALPROPERTIES')[0];
			if (remark) {
				return remark.content.split('\n').map((x,i) => {
					const o = x.split(':');
					if (o && o.length === 2) {
						return {
							key: o[0].trim(),
							value: o[1].trim(),
							id: i
						};
					}
				}).filter(x => typeof x !== 'undefined');
			}
		}
	}

};
</script>

<style lang="scss">
.product {
	z-index: 1;
	overflow-x: auto;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	max-height: 100vh;
	padding-top: 1rem;
	margin-top: -1rem;
	min-width: calc(100% + .7rem);
	padding-bottom: 50vh;


	display: flex;
	margin-left: -.7rem;
	align-items: flex-start;

	// https://codepen.io/matthewbeta/pen/fzoHI
	background-image:
	/* Shadows */
	linear-gradient(to right, white, white),
	linear-gradient(to right, white, white),

	/* Shadow covers */
	linear-gradient(to right, rgba(0,0,0,.25), rgba(255,255,255,0)),
	linear-gradient(to left, rgba(0,0,0,.25), rgba(255,255,255,0));

	background-position: 0.7rem center, right center, 0.7rem center, right center;
	background-repeat: no-repeat;
	background-color: white;
	background-size: 1.4rem 100%, 1.4rem 100%, 0.7rem 100%, 0.7rem 100%;
	background-attachment: local, local, scroll, scroll; /* Opera doesn't support this in the shorthand */


	@include greater(750) {
		position: absolute;
		flex-wrap: wrap;
		overflow-x: hidden;
		align-items: stretch;
		margin-right: -.7rem;
		min-width: calc(100% + 1.4rem);
		padding-bottom: 0;
		&:after {
			content: '';
			height: 30vh;
			display: block;
			width: 100%;
		}
	}
	&__item {
		margin: 0 .7rem 1.4rem .7rem;
		border: 1px solid $filter_border;
		display: flex;
		flex-direction: column;
		border-radius: 1.2rem;

		flex-basis: calc(100% - #{3 * 1.4rem});
		flex-shrink: 0;

		@include greater(500) {
			flex-basis: calc(50% - #{2 * 1.4rem});
		}
		@include greater(750) {
			flex-basis: calc(33.3% - 1.4rem);
		}
		@include greater(1020) {
			flex-basis: calc(25% - 1.4rem);
		}
		@include greater(1280) {
			flex-basis: calc(20% - 1.4rem);

		}
		&--hidden {
			display: none;
		}
		&--loading {
			filter: grayscale(1);
			color: #777;
			animation: load 1.3s infinite cubic-bezier(.5,.8,.8,.5);
		}
	}
	&__class {
		background: $filter_bg_active;
		color: $filter_bg;
		position: relative;
		padding: 0.2rem 1rem;
		border-top-left-radius: 1rem;
		border-top-right-radius: 1rem;
	}
	&__imagewrap {
		background-size: contain;
		background-position: 50% 50%;
		padding-top: 60%;
		background-repeat: no-repeat;
	}
	&__infowrap {
		padding: 1rem;
	}
	&__title {
		font-size: 1.3rem;
		font-weight: 500;
		margin-bottom: 1rem;
		line-height: 1.1;
	}
	&__specs {
		margin-bottom: 1rem;
	}
	&__desc {
		font-size: 1rem;
		line-height: 1.3;
	}
	&__button {
		outline: none;
		background: $button_main_bg;
		border: 0.15rem solid $button_main_border;
		border-radius: 10rem;
		padding: 0.1rem 1rem;
		color: $button_main_txt;
		margin: auto 1rem .8rem;

		&:hover, &:focus {
			background: $button_main_bg_hover;
		}
	}
}
.specs {
	font-size: .9rem;
	font-style: italic;
	border-bottom: 1px solid $filter_border;
	display: flex;
	flex-wrap: wrap;
	&__key {
		width: 63%;
		border-top: 1px solid $filter_border;
		padding: .2rem 0;
		&:after {
			content: ':';
		}

	}
	&__val {
		border-top: 1px solid $filter_border;
		padding: .2rem 0;
		white-space: nowrap;
		width: 37%;
	}
}
</style>
